import { render } from "./batchTables.vue?vue&type=template&id=0caf31fc&scoped=true"
import script from "./batchTables.vue?vue&type=script&lang=js"
export * from "./batchTables.vue?vue&type=script&lang=js"

import "./batchTables.vue?vue&type=style&index=0&id=0caf31fc&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0caf31fc"]])

export default __exports__